import TextBlock from 'components/Common/TextBlock/TextBlock'

export default function SoftwareMusicAbout() {
	return (
		<div className='about-text'>
			<TextBlock>
				I lived most of my life focusing on developing a career in music,
				specifically in trombone as a performer and educator. After taking an
				entrepreneurship class while working towards my masters degree, I started
				introducing myself to coding and moved forward with the intention of
				incorporating that in an entrepreneurial role in my music career. As I
				became further immersed in the world of development, I became more
				passionate about it. That fact coupled with the impact COVID-19 had on the
				arts led to me shifting my focus from music to software development, and I
				haven’t looked back since.
			</TextBlock>
			<TextBlock>
				Staying involved in the world of music is still important to me; I love
				supporting my wife, Taylor, in her opera career and attending her many
				performances. I try to keep my chops in shape by playing my trombone in my
				spare time, whether it’s on my own personal projects or with a local
				ensemble. Likewise, I enjoy making myself available to mentor other young
				musicians.
			</TextBlock>
			<TextBlock>
				My goal is to use my unique background in music to bring a different
				perspective to the teams and businesses I work with to create the best
				possible products that stand out from the competition.
			</TextBlock>
		</div>
	)
}
